/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult
 */
export interface JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult
     */
    sites?: Array<string>;
}

/**
 * Check if a given object implements the JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult interface.
 */
export function instanceOfJumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResultFromJSON(json: any): JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult {
    return JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResultFromJSONTyped(json, false);
}

export function JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sites': !exists(json, 'sites') ? undefined : json['sites'],
    };
}

export function JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResultToJSON(value?: JumboPostsentineloneverifytokenPostSentinelOneVerifyTokenHandlerResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sites': value.sites,
    };
}

